import { PreviousAddressFormModel_MX } from './formModel';

export const getInitialValues = (timeAtAddressTo: string): PreviousAddressFormModel_MX => {
  return {
    addressLine1: '',
    addressLine2: '',
    addressLine3: '',
    eirCode: '',
    town: '',
    county: '',
    residentialStatus: '',
    timeAtAddressFrom: '',
    timeAtAddressTo,
  };
};
